import { JsonRpcSigner } from "@ethersproject/providers";
import { ChecksumAddress, SigningProvider } from "@silo/types";

function getSigner(signingProvider: SigningProvider, account: ChecksumAddress): JsonRpcSigner {
  return signingProvider.getSigner(account).connectUnchecked();
}

export function getProviderOrSigner(
  signingProvider: SigningProvider,
  account?: ChecksumAddress
): SigningProvider | JsonRpcSigner {
  return account ? getSigner(signingProvider, account) : signingProvider;
}
